/**
 * Copyright 2018 Phenix Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
define([
    'phenix-web-lodash-light',
    'phenix-web-assert',
    'phenix-web-disposable'
], function(_, assert, disposable) {
    'use strict';

    function Event() {
        this._listeners = [];
    }

    Event.prototype.fire = function(args, context) {
        fireEvent.call(this, args, context);
    };

    Event.prototype.fireAsync = function(args, context, callback) {
        fireEvent.call(this, args, context, callback || function() {});
    };

    Event.prototype.listen = function(listener) {
        var that = this;

        assert.isFunction(listener, 'listener');

        that._listeners.push(listener);

        return new disposable.Disposable(function() {
            that._listeners = _.remove(that._listeners, function(item) {
                return item === listener;
            });
        });
    };

    Event.prototype.size = function() {
        return this._listeners.length;
    };

    Event.prototype.dispose = function() {
        this._listeners = [];
    };

    Event.prototype.toString = function() {
        return 'Event|' + this.size();
    };

    function fireEvent(args, context, asyncCallback) {
        var that = this;

        if (_.isNullOrUndefined(args)) {
            args = [];
        }

        assert.isArray(args, 'args');

        var notifyListeners = function notifyListeners() {
            _.forEach(that._listeners, function(listener) {
                listener.apply(context, args);
            });
        };

        if (asyncCallback) {
            setTimeout(function() {
                notifyListeners();
                asyncCallback();
            }, 0);
        } else {
            notifyListeners();
        }
    }

    return Event;
});